import { _ } from 'svelte-i18n'
import { get } from 'svelte/store'
import { find } from 'lodash'


/**
 * Get modal title based on current mode
 */
export function getModalTitle(mode) {
  return mode === 'upload' 
    ? get(_)('modals.uploadSelected.title')
    : get(_)('modals.addToStorefront.title')
}

/**
 * Get intro text based on current mode
 */
export function getIntroText(mode, selectedFontsCount = 0, oversizedFontsCount = 0) {
  const validFontsCount = selectedFontsCount - oversizedFontsCount
  return mode === 'upload'
    ? get(_)('modals.uploadSelected.intro')
    : selectedFontsCount === validFontsCount
      ? get(_)('modals.addToStorefront.intro', { 
          values: { selected: selectedFontsCount, valid: validFontsCount } 
        })
      : get(_)('modals.addToStorefront.intro2', { 
          values: { selected: selectedFontsCount, valid: validFontsCount } 
        })
}

/**
 * Get button text based on mode and upload state
 */
export function getButtonText(mode, uploadProgress, validFontsCount) {
  if (uploadProgress?.uploaded !== undefined) {
    return get(_)('buttons.uploading', { 
      values: { 
        uploaded: uploadProgress.uploaded, 
        total: uploadProgress.total 
      } 
    })
  }
  
  if (mode === 'upload') {
    return validFontsCount > 0 
      ? get(_)('buttons.upload') 
      : get(_)('buttons.close')
  }
  
  return get(_)('modals.addToStorefront.title')
}

/**
 * Get error message based on current mode
 */
export function getErrorMessage(mode) {
  return mode === 'upload'
    ? get(_)('modals.uploadSelected.saveError')
    : get(_)('modals.addToStorefront.saveError')
}

/**
 * Generate success message for upload operations
 */
export function generateUploadSuccessMessage(fontsUploadedCount) {
  if (fontsUploadedCount > 0) {
    return {
      message: get(_)('flashes.fontsUploaded', {
        values: { count: fontsUploadedCount }
      }),
      bright: true
    }
  } else {
    return {
      message: get(_)('flashes.noFontsToUpload'),
      bright: true
    }
  }
}

/**
 * Generate success message for storefront operations
 */
export function generateStorefrontSuccessMessage(storefrontName, fontsCount, userStorefronts) {
  const existingStorefront = find(userStorefronts, (s) => 
    s.name.toLowerCase() === storefrontName.toLowerCase()
  )
  
  if (existingStorefront) {
    return {
      message: get(_)('flashes.storefrontFontsAdded', {
        values: { count: fontsCount, storefront_name: storefrontName }
      }),
      bright: true
    }
  } else {
    return {
      message: get(_)('flashes.storefrontCreatedWithFonts', {
        values: { count: fontsCount, storefront_name: storefrontName }
      }),
      bright: true
    }
  }
}

/**
 * Generate success message for upload or storefront operations
 */
export function generateSuccessMessage(mode, options = {}) {
  const {
    fontsUploadedCount = 0,
    storefrontName = '',
    fontsValidForStorefrontCount = 0,
    userStorefronts = [],
  } = options

  if (mode === 'upload') {
    return generateUploadSuccessMessage(fontsUploadedCount)
  } else {
    return generateStorefrontSuccessMessage(
      storefrontName, 
      fontsValidForStorefrontCount, 
      userStorefronts
    )
  }
}